export const ColorMarkers = {
  'D': 'D',
  'E': 'E',
  'F': 'F',
  'G': 'G',
  'H': 'H',
  'I': 'I',
  'J': 'J',
  'K-O': 'K-O',
  'P-Z': 'P-Z'
}

export const ClarityMarkers = {
  'FL': 'FL',
  'IF': 'IF',
  'VVS1': 'VVS1',
  'VVS2': 'VVS2',
  'VS1': 'VS1',
  'VS2': 'VS2',
  'SI1': 'SI1',
  'SI2': 'SI2',
  'SI3': 'SI3',
  'I1': 'I1',
  'I2': 'I2',
  'I3': 'I3'
}

export const FluorescenceIntensityMarkers = {
  'None': 'N',
  'Very Slight': 'VSL',
  'Slight': 'SL',
  'Faint': 'F',
  'Medium': 'M',
  'Strong': 'S',
  'Very Strong': 'VS'
}

export const FancyIntensityMarkers = {
  'Faint': 'F',
  'Very Light': 'VL',
  'Light': 'L',
  'Fancy Light': 'FL',
  'Fancy': 'FC',
  'Fancy Dark': 'FCD',
  'Fancy Intense': 'I',
  'Fancy Vivid': 'FV',
  'Fancy Deep': 'D'
}

export const CutMarkers = {
  'Ideal': 'I',
  'Excellent': 'EX',
  'Very Good': 'VG',
  'Good': 'G',
  'Fair': 'F',
  'Poor': 'P'
}

export const PolishMarkers = {
  'Ideal': 'I',
  'Excellent': 'EX',
  'Very Good': 'VG',
  'Good': 'G',
  'Fair': 'F',
  'Poor': 'P'
}

export const SymmetryMarkers = {
  'Ideal': 'I',
  'Excellent': 'EX',
  'Very Good': 'VG',
  'Good': 'G',
  'Fair': 'F',
  'Poor': 'P'
}



// WEBPACK FOOTER //
// ./src/utils/slider-markers.js